import get from 'lodash.get';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { I18n, Translate } from 'react-redux-i18n';
import { Container, Menu, Header, Message } from 'semantic-ui-react';
import { Common } from '../../../components';
import { ConsentAuditPanel } from '../../consentAudit';
import Grid from '../../../components/common/grid';
import MembershipItem from '../../../components/common/MembershipItem/MembershipItem';
import { i18nKeys, tabs } from '../constants';

// Actions
import { withRouterV6 } from '../../../helpers/withRouterV6.jsx';
import { bindActionCreators } from 'redux';
import ContextMenu from '../../../components/common/grid/contextMenu';
import MarkSpamModal from '../../../components/common/MarkSpamModal';
import { CONTEXT_MENU_KEYS } from '../../../constants/contextMenuEntries';
import { gridKeys } from '../../../constants/gridKeys';
import { pageTypesStrings } from '../../../constants/pageTypes';
import {
  impersonatePageManager,
  setRedirectUrl
} from '../../../modules/session';
import {
  OFFLINE_DONATION_TYPE, ONLINE_DONATION_TYPE, PLEDGE_DONATION_TYPE
} from '../../campaign/constants';
import ReceiptWindowContainer from '../../donation/receipt-window';
import * as donationsActions from '../../donation/store/donationActions';
import * as campaignActions from '../../campaign/store/campaignActions';
import {
  getMarkSpamModalConfigForRow,
  getPageIdForRow,
  normalizeRowAsSpamEntity
} from '../../fundraiser/markSpamRowHelpers';
import RefundWindowContainer from '../../donation/refund-window';
import * as accountActions from './store/accountDetailActions';
import {
  SystemOnlyIcon,
  SystemOnlyPopup
} from '../../../components/common/SystemOnlyBadge';
;

class DonationsTable extends Component {
  state = { selectedSpamRow: null };

  isViewSelected(view) {
    return this.props.match.params.tab === view;
  }

  hideMarkSpamContextMenuItem = (item) => {
    return !this.props.isSystemAdmin || !!item?.isSpam;
  };

  onMarkSpamContextClick = (_id, item) => {
    this.setState({ selectedSpamRow: normalizeRowAsSpamEntity(item) });
    this.props.campaignActions.showMarkSpamConfirmation();
  };

  renderMarkSpamModal = () => {
    const row = this.state.selectedSpamRow;
    const { pageType, getRecord, translationBase } = getMarkSpamModalConfigForRow(row);
    return (
      <MarkSpamModal
        entityId={getPageIdForRow(row)}
        entity={row}
        stateSliceKey="campaign"
        markAsSpam={(id) => campaignActions.markPageAsSpam(pageType, id)}
        hideConfirmation={campaignActions.hideMarkSpamConfirmation}
        getRecord={getRecord}
        translationBase={translationBase}
      />
    );
  };

  handleMenuItemClick = (e, { name }) => {
    this.props.history.push(
      `/accounts/detail/${this.props.match.params.id}/${name}`
    );
  };

  getTabsButtons = (hasFundraising, hasDonations, hasSales, hasDonationSubscriptions, hasAdmin, hasPlacehubApplications) => {
    // The consent audit exists for every account, so the strip renders for sysadmins even
    // when the account has no linked data.
    if (hasFundraising || hasDonations || hasSales || hasDonationSubscriptions || hasAdmin || hasPlacehubApplications || this.props.isSystemAdmin) {
      return (
        <Menu
          className="accounts-tab-buttons-group"
          style={{ margin: '0px', borderRight: '0px' }}
        >
          {hasFundraising && (
            <Menu.Item
              name={tabs.FUNDRAISING}
              active={this.isViewSelected(tabs.FUNDRAISING)}
              onClick={this.handleMenuItemClick}
            >
              <Translate value={i18nKeys.FUNDRAISING_TAB_TITLE} />
            </Menu.Item>
          )}
          {hasDonations && (
            <Menu.Item
              name={tabs.DONATIONS}
              active={this.isViewSelected(tabs.DONATIONS)}
              onClick={this.handleMenuItemClick}
            >
              <Translate value={i18nKeys.DONATIONS_TAB_TITLE} />
            </Menu.Item>
          )}
          {hasSales && (
            <Menu.Item
              name={tabs.SALES}
              active={this.isViewSelected(tabs.SALES)}
              onClick={this.handleMenuItemClick}
            >
              <Translate value={i18nKeys.SALES_TAB_TITLE} />
            </Menu.Item>
          )}
          {hasDonationSubscriptions && (
            <Menu.Item
              name={tabs.DONATION_SUBSCRIPTIONS}
              active={this.isViewSelected(tabs.DONATION_SUBSCRIPTIONS)}
              onClick={this.handleMenuItemClick}
            >
              <Translate value={i18nKeys.DONATION_SUBSCRIPTIONS_TAB_TITLE} />
            </Menu.Item>
          )}
          {hasAdmin && (
            <Menu.Item
              name={tabs.ADMIN}
              active={this.isViewSelected(tabs.ADMIN)}
              onClick={this.handleMenuItemClick}
            >
              <Translate value={i18nKeys.ADMIN_TAB_TITLE} />
            </Menu.Item>
          )}
          {hasPlacehubApplications && (
            <Menu.Item
              name={tabs.PLACEHUB_APPLICATIONS}
              active={this.isViewSelected(tabs.PLACEHUB_APPLICATIONS)}
              onClick={this.handleMenuItemClick}
            >
              <Translate value={i18nKeys.PLACEHUB_APPLICATIONS_TAB_TITLE} />
            </Menu.Item>
          )}
          {this.props.isSystemAdmin && (
            <SystemOnlyPopup>
              <Menu.Item
                name={tabs.CONSENT}
                active={this.isViewSelected(tabs.CONSENT)}
                onClick={this.handleMenuItemClick}
              >
                <Translate value={i18nKeys.CONSENT_TAB_TITLE} />
                <SystemOnlyIcon />
              </Menu.Item>
            </SystemOnlyPopup>
          )}
        </Menu>
      );
    }
  };

  setDefaultView(hasFundraising, hasDonations, hasSales, hasDonationSubscriptions, hasAdmin, hasPlacehubApplications) {
    const id = this.props.match.params.id;
    const tab = hasFundraising ? tabs.FUNDRAISING
      : hasDonations ? tabs.DONATIONS
      : hasSales ? tabs.SALES
      : hasDonationSubscriptions ? tabs.DONATION_SUBSCRIPTIONS
      : hasAdmin ? tabs.ADMIN
      : hasPlacehubApplications ? tabs.PLACEHUB_APPLICATIONS
      : this.props.isSystemAdmin ? tabs.CONSENT
      : null;

    if (tab) {
      this.props.setView(tab);
      this.props.history.replace(`/accounts/detail/${id}/${tab}`);
    }
  }

  hideColumnCondition = (item) => {
    // organization.name is sysadmin-only across all account detail grids
    if (!this.props.isSystemAdmin && item.path === 'organization.name') {
      return true;
    }
    return false;
  };

  isContextMenuItemHide = (item) => {
    return item.type === pageTypesStrings.FUNDRAISER;
  };

  isViewFundraiserContextMenuItemHidden = (item) => {
    return !this.props.isSystemAdmin;
  };

  onRefundContextClick = (id, item) => {
    this.props.donationActions.showRefundConfirmation(item);
  };

  hideRefundButton = (item) => {
    return item.type !== ONLINE_DONATION_TYPE;
  };

  hideDeleteButton = (item) => {
    return (
      item.type !== OFFLINE_DONATION_TYPE && item.type !== PLEDGE_DONATION_TYPE
    );
  };

  onViewContextClick = (id, item) => {
    this.props.history.push(`/donations/view/${id}`);
  };

  onReissueContextClick = (id, item) => {
    if (item.donor.email) {
      this.props.donationActions.showReceiptConfirmation(item);
    } else {
      this.props.donationActions.getReceiptMessageError('saveRecord');
    }
  };

  onImpersonateFundraiserContextClick = (id, item) => {
    this.props.impersonatePageManager(item.accountId, item.urlFull);
  };

  renderAdminTab = () => {
    const adminMemberships = this.props.adminMemberships || [];
    const revokedMemberships = this.props.revokedMemberships || [];

    return (
      <div style={{ paddingTop: '16px', clear: 'both' }}>
        {adminMemberships.length > 0 && (
          <div style={{ marginBottom: '24px' }}>
            <Header as="h3">
              <Translate value={i18nKeys.ACTIVE_MEMBERSHIPS} />
            </Header>
            {adminMemberships.map((membership) => (
              <MembershipItem
                key={membership.id}
                membership={membership}
              />
            ))}
          </div>
        )}
        {revokedMemberships.length > 0 && (
          <div style={{ marginBottom: '24px' }}>
            <Header as="h3">
              <Translate value={i18nKeys.REVOKED_MEMBERSHIPS} />
            </Header>
            {revokedMemberships.map((membership) => (
              <MembershipItem
                key={membership.id}
                membership={membership}
                isExpired
              />
            ))}
          </div>
        )}
        {adminMemberships.length === 0 && revokedMemberships.length === 0 && (
          <Message info>
            <Message.Content>
              <Translate value={i18nKeys.NO_MEMBERSHIPS} />
            </Message.Content>
          </Message>
        )}
      </div>
    );
  };

  render() {
    const accountData = this.props.accountData;

    const hasFundraising = accountData.hasPagesLinked;
    const hasDonations = accountData.hasDonationsLinked;
    const hasSales = accountData.hasSalesLinked;
    const hasDonationSubscriptions = accountData.hasDonationSubscriptionsLinked;
    const hasAdmin =
      (this.props.adminMemberships && this.props.adminMemberships.length > 0) ||
      (this.props.revokedMemberships && this.props.revokedMemberships.length > 0);
    const hasPlacehubApplications = accountData.hasEventAmbassadorsLinked;

    // Redirect to a valid tab if current URL tab is missing or unavailable
    const currentTab = this.props.match.params.tab;
    const isCurrentTabValid =
      (currentTab === tabs.FUNDRAISING && hasFundraising) ||
      (currentTab === tabs.DONATIONS && hasDonations) ||
      (currentTab === tabs.SALES && hasSales) ||
      (currentTab === tabs.DONATION_SUBSCRIPTIONS && hasDonationSubscriptions) ||
      (currentTab === tabs.ADMIN && hasAdmin) ||
      (currentTab === tabs.PLACEHUB_APPLICATIONS && hasPlacehubApplications) ||
      (currentTab === tabs.CONSENT && this.props.isSystemAdmin);

    if (!currentTab || !isCurrentTabValid) {
      this.setDefaultView(hasFundraising, hasDonations, hasSales, hasDonationSubscriptions, hasAdmin, hasPlacehubApplications);
    }

    const tabsButtons = this.getTabsButtons(hasFundraising, hasDonations, hasSales, hasDonationSubscriptions, hasAdmin, hasPlacehubApplications);
    const isDonationsViewSelected = this.isViewSelected(tabs.DONATIONS);
    const isFundraisingViewSelected = this.isViewSelected(tabs.FUNDRAISING);
    const isSalesViewSelected = this.isViewSelected(tabs.SALES);
    const isDonationSubscriptionsViewSelected = this.isViewSelected(tabs.DONATION_SUBSCRIPTIONS);
    const isAdminViewSelected = this.isViewSelected(tabs.ADMIN);
    const isPlacehubApplicationsViewSelected = this.isViewSelected(tabs.PLACEHUB_APPLICATIONS);
    const baseFilter = {
      key: 'accountId',
      operator: 'EqualTo',
      value: this.props.match.params.id
    };

    return (
      <Container className="donations-container">
        <RefundWindowContainer />
        <ReceiptWindowContainer />
        {this.renderMarkSpamModal()}

        {tabsButtons}
        {isDonationsViewSelected && hasDonations && (
          <Grid.Managed
            listKey={gridKeys.ACCOUNT_VIEW_DONATIONS}
            list={this.props.list}
            actions={this.props.donationActionGrid}
            search
            toggleColumns
            filter={baseFilter}
            hideColumn={this.hideColumnCondition}
          >
            <ContextMenu>
              <ContextMenu.Item
                key={CONTEXT_MENU_KEYS.ACCOUNT_DETAILS.VIEW_DONATION.key}
                label={I18n.t('donation.list.context.view-donation')}
                contextMenuOptions={
                  CONTEXT_MENU_KEYS.ACCOUNT_DETAILS.VIEW_DONATION
                }
              />
              <ContextMenu.Item
                key={CONTEXT_MENU_KEYS.ACCOUNT_DETAILS.EDIT_DONATION.key}
                label={I18n.t('donation.list.context.edit-donation')}
                contextMenuOptions={
                  CONTEXT_MENU_KEYS.ACCOUNT_DETAILS.EDIT_DONATION
                }
                onClick={() =>
                  this.props.setRedirectUrl(
                    this.props.location.pathname
                  )
                }
              />
              <ContextMenu.Item
                key={CONTEXT_MENU_KEYS.ACCOUNT_DETAILS.REFUND_DONATION.key}
                label={I18n.t('donation.list.context.refund-donation')}
                onClick={this.onRefundContextClick}
                isHiden={this.hideRefundButton}
              />
              <ContextMenu.Item
                key={CONTEXT_MENU_KEYS.ACCOUNT_DETAILS.DELETE_DONATION.key}
                label={I18n.t('donation.list.context.delete-donation')}
                onClick={this.onRefundContextClick}
                isHiden={this.hideDeleteButton}
              />
              <ContextMenu.Item
                key={CONTEXT_MENU_KEYS.ACCOUNT_DETAILS.REISSUE_RECEIPT.key}
                label={I18n.t('donation.list.context.reissue-receipt')}
                onClick={this.onReissueContextClick}
              />
            </ContextMenu>
          </Grid.Managed>
        )}
        {isFundraisingViewSelected && hasFundraising && (
          <Grid.Managed
            listKey={gridKeys.ACCOUNT_VIEW_FUNDRAISING}
            list={this.props.fundraisinglist}
            actions={this.props.fundraisingActionGrid}
            search
            filter={baseFilter}
            toggleColumns
            hideColumn={this.hideColumnCondition}
          >
            <ContextMenu>
              <ContextMenu.Item
                key={CONTEXT_MENU_KEYS.ACCOUNT_DETAILS.VIEW_FUNDRAISER.key}
                label={I18n.t('campaign.list.view.context.view-fundraiser')}
                contextMenuOptions={CONTEXT_MENU_KEYS.ACCOUNT_DETAILS.VIEW_FUNDRAISER}
              />
              <ContextMenu.Item
                key={CONTEXT_MENU_KEYS.ACCOUNT_DETAILS.EDIT_PAGE.key}
                label={I18n.t('campaign.list.view.context.edit-page')}
                contextMenuOptions={CONTEXT_MENU_KEYS.ACCOUNT_DETAILS.EDIT_PAGE}
                onClick={() =>
                  this.props.setRedirectUrl(
                    this.props.location.pathname
                  )
                }
              />
              <ContextMenu.Item
                key={CONTEXT_MENU_KEYS.ACCOUNT_DETAILS.NAVIGATE_TO_PUBLIC.key}
                label={I18n.t('campaign.list.view.context.view-public-page')}
                contextMenuOptions={
                  CONTEXT_MENU_KEYS.ACCOUNT_DETAILS.NAVIGATE_TO_PUBLIC
                }
              />
              <ContextMenu.Item
                key={CONTEXT_MENU_KEYS.ACCOUNT_DETAILS.VIEW_PAGE_DONATIONS.key}
                label={I18n.t('campaign.list.view.context.view-page-donations')}
                contextMenuOptions={
                  CONTEXT_MENU_KEYS.ACCOUNT_DETAILS.VIEW_PAGE_DONATIONS
                }
              />
              {this.props.isSystemAdmin && (
                <ContextMenu.Item
                  key={
                    CONTEXT_MENU_KEYS.ACCOUNT_DETAILS.IMPERSONATE_FUNDRAISER.key
                  }
                  label={I18n.t(
                    'campaign.list.view.context.impersonate-fundraiser-page'
                  )}
                  onClick={this.onImpersonateFundraiserContextClick}
                  systemOnly
                />
              )}
              <ContextMenu.Item
                key={CONTEXT_MENU_KEYS.ACCOUNT_DETAILS.MARK_AS_SPAM.key}
                label={I18n.t('campaign.list.view.context.mark-as-spam')}
                contextMenuOptions={CONTEXT_MENU_KEYS.ACCOUNT_DETAILS.MARK_AS_SPAM}
                onClick={this.onMarkSpamContextClick}
                isHiden={this.hideMarkSpamContextMenuItem}
              />
            </ContextMenu>
          </Grid.Managed>
        )}
        {isAdminViewSelected && hasAdmin && this.renderAdminTab()}
        {isSalesViewSelected && hasSales && (
          <Grid.Managed
            listKey={gridKeys.ACCOUNT_VIEW_SALES}
            list={this.props.salesList}
            actions={this.props.salesActionGrid}
            search
            toggleColumns
            filter={baseFilter}
            hideColumn={this.hideColumnCondition}
          >
            <ContextMenu>
              <ContextMenu.Item
                key={CONTEXT_MENU_KEYS.ACCOUNT_DETAILS.VIEW_SALE.key}
                label={I18n.t('sale.list.context.view-sale')}
                contextMenuOptions={
                  CONTEXT_MENU_KEYS.ACCOUNT_DETAILS.VIEW_SALE
                }
              />
              <ContextMenu.Item
                key={CONTEXT_MENU_KEYS.ACCOUNT_DETAILS.EDIT_SALE.key}
                label={I18n.t('sale.list.context.edit-sale')}
                contextMenuOptions={
                  CONTEXT_MENU_KEYS.ACCOUNT_DETAILS.EDIT_SALE
                }
                onClick={() =>
                  this.props.setRedirectUrl(
                    this.props.location.pathname
                  )
                }
              />
            </ContextMenu>
          </Grid.Managed>
        )}
        {isDonationSubscriptionsViewSelected && hasDonationSubscriptions && (
          <Grid.Managed
            listKey={gridKeys.ACCOUNT_VIEW_DONATION_SUBSCRIPTIONS}
            list={this.props.donationSubscriptionsList}
            actions={this.props.donationSubscriptionsActionGrid}
            search
            toggleColumns
            filter={baseFilter}
            hideColumn={this.hideColumnCondition}
          >
            <ContextMenu>
              <ContextMenu.Item
                key={CONTEXT_MENU_KEYS.ACCOUNT_DETAILS.VIEW_DONATION_SUBSCRIPTION.key}
                label={I18n.t('recurring.list.context.view-donation-subscription')}
                contextMenuOptions={
                  CONTEXT_MENU_KEYS.ACCOUNT_DETAILS.VIEW_DONATION_SUBSCRIPTION
                }
              />
              <ContextMenu.Item
                key={CONTEXT_MENU_KEYS.ACCOUNT_DETAILS.EDIT_DONATION_SUBSCRIPTION.key}
                label={I18n.t('recurring.list.context.edit-donation-subscription')}
                contextMenuOptions={
                  CONTEXT_MENU_KEYS.ACCOUNT_DETAILS.EDIT_DONATION_SUBSCRIPTION
                }
                onClick={() =>
                  this.props.setRedirectUrl(
                    this.props.location.pathname
                  )
                }
              />
            </ContextMenu>
          </Grid.Managed>
        )}
        {isPlacehubApplicationsViewSelected && hasPlacehubApplications && (
          <Grid.Managed
            listKey={gridKeys.ACCOUNT_VIEW_PLACEHUB_APPLICATIONS}
            list={this.props.placehubApplicationsList}
            actions={this.props.placehubApplicationsActionGrid}
            search
            toggleColumns
            filter={baseFilter}
            hideColumn={this.hideColumnCondition}
          >
            <ContextMenu>
              <ContextMenu.Item
                key={CONTEXT_MENU_KEYS.ACCOUNT_DETAILS.VIEW_PLACEHUB_APPLICATION.key}
                label={I18n.t('applications.list.context.view-application')}
                contextMenuOptions={
                  CONTEXT_MENU_KEYS.ACCOUNT_DETAILS.VIEW_PLACEHUB_APPLICATION
                }
              />
            </ContextMenu>
          </Grid.Managed>
        )}
        {this.isViewSelected(tabs.CONSENT) && this.props.isSystemAdmin && (
          <ConsentAuditPanel accountId={Number(this.props.match.params.id)} />
        )}
      </Container>
    );
  }
}

const mapState = ({ accountDetail, session }) => {
  const list = get(accountDetail, `${gridKeys.ACCOUNT_VIEW_DONATIONS}`);
  const fundraisinglist = get(
    accountDetail,
    `${gridKeys.ACCOUNT_VIEW_FUNDRAISING}`
  );
  const salesList = get(
    accountDetail,
    `${gridKeys.ACCOUNT_VIEW_SALES}`
  );
  const donationSubscriptionsList = get(
    accountDetail,
    `${gridKeys.ACCOUNT_VIEW_DONATION_SUBSCRIPTIONS}`
  );
  const placehubApplicationsList = get(
    accountDetail,
    `${gridKeys.ACCOUNT_VIEW_PLACEHUB_APPLICATIONS}`
  );
  const accountData = get(accountDetail, 'detailRecord.data.data', {});

  return {
    selectedView: accountDetail.selectedView,
    list: list,
    fundraisinglist: fundraisinglist,
    salesList: salesList,
    donationSubscriptionsList: donationSubscriptionsList,
    placehubApplicationsList: placehubApplicationsList,
    accountData: accountData,
    isOrganizationAdmin: get(session, 'isOrganizationAdmin'),
    isSystemAdmin: get(session, 'isSystemAdmin'),
    adminMemberships: accountData.adminMemberships || [],
    revokedMemberships: accountData.revokedMemberships || []
  };
};

const mapDispatch = (dispatch) => {
  var donationTabActions = {
    getMetadata: accountActions.getDonationsMetadata,
    getListData: accountActions.getDonationsListData,
    getListDataBySearchTerm: accountActions.getDonationsListDataBySearchTerm,
    toggleColumnsChange: accountActions.donationsToggleColumnsChange
  };

  var fundraisingActions = {
    getMetadata: accountActions.getFundraisingMetadata,
    getListData: accountActions.getFundraisingListData,
    getListDataBySearchTerm: accountActions.getFundraisingListDataBySearchTerm,
    toggleColumnsChange: accountActions.fundraisingToggleColumnsChange,
    onValueChange: accountActions.onValueChange
  };

  var salesTabActions = {
    getMetadata: accountActions.getSalesMetadata,
    getListData: accountActions.getSalesListData,
    getListDataBySearchTerm: accountActions.getSalesListDataBySearchTerm,
    toggleColumnsChange: accountActions.salesToggleColumnsChange
  };

  var donationSubscriptionsTabActions = {
    getMetadata: accountActions.getDonationSubscriptionsMetadata,
    getListData: accountActions.getDonationSubscriptionsListData,
    getListDataBySearchTerm: accountActions.getDonationSubscriptionsListDataBySearchTerm,
    toggleColumnsChange: accountActions.donationSubscriptionsToggleColumnsChange
  };

  var placehubApplicationsTabActions = {
    getMetadata: accountActions.getPlacehubApplicationsMetadata,
    getListData: accountActions.getPlacehubApplicationsListData,
    getListDataBySearchTerm: accountActions.getPlacehubApplicationsListDataBySearchTerm,
    toggleColumnsChange: accountActions.placehubApplicationsToggleColumnsChange
  };

  const donationActionGrid = Common.Grid.Managed.bindGridActions(
    dispatch,
    donationTabActions
  );
  const fundraisingActionGrid = Common.Grid.Managed.bindGridActions(
    dispatch,
    fundraisingActions
  );
  const salesActionGrid = Common.Grid.Managed.bindGridActions(
    dispatch,
    salesTabActions
  );
  const donationSubscriptionsActionGrid = Common.Grid.Managed.bindGridActions(
    dispatch,
    donationSubscriptionsTabActions
  );
  const placehubApplicationsActionGrid = Common.Grid.Managed.bindGridActions(
    dispatch,
    placehubApplicationsTabActions
  );
  const donationActions = bindActionCreators(donationsActions, dispatch);

  return {
    setRedirectUrl: bindActionCreators(setRedirectUrl, dispatch),
    donationActions,
    campaignActions: bindActionCreators(
      { showMarkSpamConfirmation: campaignActions.showMarkSpamConfirmation },
      dispatch
    ),
    donationActionGrid,
    fundraisingActionGrid,
    salesActionGrid,
    donationSubscriptionsActionGrid,
    placehubApplicationsActionGrid,
    setView(view) {
      dispatch(accountActions.setView(view));
    },
    impersonatePageManager(accountId, urlFull) {
      dispatch(impersonatePageManager(accountId, urlFull));
    }
  };
};

const AccountDetailDonationsContainer = withRouterV6(
  connect(mapState, mapDispatch)(DonationsTable)
);
export default AccountDetailDonationsContainer;
